export const buildSessionSnapshot = (sessionStorageSnapshot = {}, persistedSession = {}) => {
  const operatorID = sessionStorageSnapshot.operatorID || persistedSession.operatorID || "";
  const sessionToken = sessionStorageSnapshot.sessionToken || persistedSession.sessionToken || "";
  const expiresAt = sessionStorageSnapshot.expiresAt || persistedSession.expiresAt || "";

  return {
    operatorID,
    sessionToken,
    expiresAt,
  };
};

export const hasCompleteSession = (session = {}) =>
  Boolean(session.operatorID && session.sessionToken && session.expiresAt);
